import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [isDark, setIsDark] = useState(() => {
        // Check localStorage for explicit user preference only
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem('saige_theme');
            if (saved) return saved === 'dark';
        }
        // Default to light mode for first-time / logged-out users
        return false;
    });

    useEffect(() => {
        // Apply dark class to html element
        if (isDark) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        localStorage.setItem('saige_theme', isDark ? 'dark' : 'light');
    }, [isDark]);

    const toggleTheme = () => setIsDark(!isDark);
    const setDark = (val) => setIsDark(val);

    return (
        <ThemeContext.Provider value={{ isDark, toggleTheme, setDark }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

export default ThemeContext;
